import * as React from 'react';
import { ConfigConsumer } from '.';
import Empty from '../empty';
const renderEmpty = (componentName) => (React.createElement(ConfigConsumer, null, ({ getPrefixCls }) => {
    const prefix = getPrefixCls('empty');
    switch (componentName) {
        case 'Table':
        case 'List':
            return React.createElement(Empty, null);
        case 'Select':
        case 'TreeSelect':
        case 'Cascader':
        case 'Transfer':
        case 'Mentions':
            return React.createElement(Empty, { className: `${prefix}-small` });
        default:
            return React.createElement(Empty, null);
    }
}));
export default renderEmpty;
